import React, { forwardRef } from 'react';
import { ArrowFatUp, ArrowFatDown, ArrowFatRight } from '@phosphor-icons/react';

import { cn } from '@/lib/utils';

export enum Trend {
  UP = 'up',
  DOWN = 'down',
  FLAT = 'flat',
}

export type TrendVariant = 'default' | 'long';

interface TrendValueProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: TrendVariant;
  trend: Trend;
  trendValue: string;
}

const TrendValue = forwardRef<HTMLDivElement, TrendValueProps>(
  ({ variant = 'default', trend, trendValue, className, ...props }, ref) => {
    let ArrowIcon = ArrowFatUp;
    switch (trend) {
      case Trend.UP:
        ArrowIcon = ArrowFatUp;
        break;
      case Trend.DOWN:
        ArrowIcon = ArrowFatDown;
        break;
      case Trend.FLAT:
        ArrowIcon = ArrowFatRight;
        break;
    }

    let commentary = '';
    let ariaLabel = '';
    let color = '';

    switch (trend) {
      case Trend.UP:
        ariaLabel = `Trending up by ${trendValue}`;
        commentary = 'Trending up by ';
        color = 'text-green-500';
        break;
      case Trend.DOWN:
        ariaLabel = `Trending down by ${trendValue}`;
        commentary = 'Trending down by ';
        color = 'text-red-500';
        break;
      case Trend.FLAT:
        ariaLabel = `No change - ${trendValue}`;
        commentary = 'No change ';
        color = 'text-dark-600';
        break;
    }

    return (
      <div ref={ref} className={cn('flex items-center gap-1', className)} {...props}>
        {variant === 'long' && <span className="text-sm">{commentary}</span>}
        <ArrowIcon weight="fill" className={cn('size-4', color)} />
        <span className={cn('text-sm font-bold', color)} aria-label={ariaLabel}>
          {trendValue}
        </span>
      </div>
    );
  },
);
TrendValue.displayName = 'TrendValue';

export { TrendValue };
